var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "24px",
    viewBox: "0 0 40 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flywire/Default",
    transform: "translate(-113.000000, -152.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flywire"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Visa",
    transform: "translate(113.533181, 152.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#F1AD2B",
    points: "0.109811048 23.8946565 38.5164555 23.8946565 38.5164555 20.4650382 0.109811048 20.4650382"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#182E66",
    points: "0.109811048 3.5008855 38.5164555 3.5008855 38.5164555 0.0712672 0.109811048 0.0712672"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9818608,7.2793282 L16.957438,16.7061985 L14.5088539,16.7061985 L16.5334606,7.2793282 L18.9818608,7.2793282 Z M29.2831304,13.3665344 L30.5721687,9.8262595 L31.3136232,13.3665344 L29.2831304,13.3665344 Z M32.0164507,16.7061985 L34.2803609,16.7061985 L32.3022905,7.2793282 L30.2138572,7.2793282 C29.7429757,7.2793282 29.3464051,7.5512061 29.1707443,7.9703817 L25.4965806,16.7061985 L28.0682192,16.7061985 L28.5786475,15.2984427 L31.7195745,15.2984427 L32.0164507,16.7061985 Z M25.6242336,13.6287023 C25.6349021,11.1409466 22.1713475,11.0029924 22.1943398,9.8912977 C22.2018812,9.5534656 22.5252444,9.1938321 23.2326704,9.1018626 C23.5832564,9.0567939 24.5507708,9.0203359 25.6475938,9.5236031 L26.0765374,7.5237252 C25.4871997,7.3115725 24.7291909,7.1071145 23.7861401,7.1071145 C21.3655147,7.1071145 19.6626157,8.3877252 19.6490042,10.223084 C19.6335534,11.5802748 20.8655709,12.3370992 21.7916992,12.7890687 C22.7465219,13.2509313 23.0665743,13.5473588 23.0619758,13.9601221 C23.0553541,14.5925496 22.3002882,14.8726718 21.5976446,14.8831145 C20.3658111,14.9023511 19.6519473,14.5516947 19.0828427,14.2873282 L18.6384483,16.3540763 C19.2114155,16.615145 20.2674041,16.842687 21.3605483,16.854229 C23.9338425,16.854229 25.6166922,15.5886412 25.6242336,13.6287023 Z M15.483174,7.2793282 L11.515813,16.7061985 L8.92780384,16.7061985 L6.97530087,9.1828397 C6.85702865,8.7204275 6.75383936,8.550229 6.39387249,8.3549313 C5.80508659,8.0361527 4.83297374,7.7382595 3.9783973,7.5530382 L4.03615387,7.2793282 L8.20271981,7.2793282 C8.73356522,7.2793282 9.21088457,7.631084 9.33228375,8.2400611 L10.3636247,13.6953893 L12.9107996,7.2793282 L15.483174,7.2793282 Z",
    id: "Fill-5",
    fill: "#182E66"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.72d8e9f5b016746aceb09624b03b9412.svg";
export { ForwardRef as ReactComponent };